import * as React from 'react';
import { HomeScreen } from './Home';

export function App(el: HTMLElement) {
    return <>
        <HomeScreen />
    </>;
}
